import React from "react";
import moment from "moment";
import { DATE_AND_TIME_FORMAT } from "utils/constants";

export function DateColumn({ value }){
	if(!value){ return null; }
	const formattedDate = moment(value).format(DATE_AND_TIME_FORMAT);

	return (
		<time dateTime={value}>{formattedDate}</time>
	);
}

const DateCell = {
	key: "dateCreated",
	name: "Date Created",
	formatter: DateColumn,
	resizable:true,
	sortable:true,
};

export default DateCell;
